import { render } from "./Praise.vue?vue&type=template&id=7f7864a0&scoped=true"
import script from "./Praise.vue?vue&type=script&lang=js"
export * from "./Praise.vue?vue&type=script&lang=js"

import "./Praise.vue?vue&type=style&index=0&id=7f7864a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7864a0"]])

export default __exports__